import { SQLGeneratedProcess } from "@avenueops/shared-types";
import { WorkflowProcessPriority } from "@prisma/client";
import PriorityButton from "components/signals/processPage/PriorityButton";
import _ from "lodash";
import React from "react";

interface Props {
  row: SQLGeneratedProcess;
}

export default function Priority({ row }: Props): JSX.Element | null {
  return (
    <div className="w-fit" onClick={(e) => e.stopPropagation()}>
      <PriorityButton processId={row.id} priority={row.priority as WorkflowProcessPriority} size="SMALL" />
    </div>
  );
}
